<div class="form__item">
  <div class="form__item-label" *ngIf="to.label">
    <label>{{to.label}}:</label>
  </div>
  <div class="form__item-control">
    <input class="form__control" type="file" [formControl]="formControl" [formlyAttributes]="field" [accept]="to.accept" appFileInputValueAccessor>
  </div>
</div>